import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Services

import { AuthenticationService } from './services/authentication/authentication.service';
import { TranslateModule } from '@ngx-translate/core';

// Common (Used on every page)

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';
import { MatMenuModule } from '@angular/material/menu';
import { NestedEllipsisModule } from 'ngx-nested-ellipsis';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSocialShareModule } from 'ngx-social-share';
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Shared

import { SharedModule } from './modules/shared/shared/shared.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { PopoverWrapperComponent } from './pages/website/timetable/timetable.component';
import { PreviousRouteService } from './services/routing/previous-route.service';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
    dayGridPlugin,
    interactionPlugin
]);

@NgModule({
    declarations: [AppComponent, PopoverWrapperComponent],
    imports: [
        TranslateModule.forRoot(),
        NgxSkeletonLoaderModule.forRoot(),
        InlineSVGModule.forRoot(),
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        SplashScreenModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        HttpClientModule,
        AppRoutingModule,
        NgbModule,
        MatExpansionModule,
        MatMenuModule,
        NestedEllipsisModule,
        FullCalendarModule,
        NgbPopoverModule,
        NgxSocialShareModule,
        MatSnackBarModule,

    ],
    entryComponents: [PopoverWrapperComponent],
    providers: [
        AuthenticationService,
        PreviousRouteService,
        { provide: 'googleTagManagerId', useValue: 'GTM-5QSJH56' }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
